import React from 'react';
import { getEventTypeName, getDateTypeName } from '../../../constants/events';
import { FirebasePushButton } from '../../misc/FirebasePushButton';

/**
 * Event Form Header Component
 * Displays form header with event type information
 */
export const EventFormHeader = ({
  eventType,
  dateType,
  eventName,
  isEdit = false,
  isCloned = false,
  record = null,
}) => {
  const eventTypeName = getEventTypeName(eventType);
  const dateTypeName = getDateTypeName(dateType);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        maxHeight: 48,
        marginBottom: 20,
        flexWrap: 'wrap',
        gap: 8,
      }}
    >
      <h2 style={{ marginLeft: 15, marginRight: 8 }}>
        {isEdit
          ? `${eventName} / ${eventTypeName} (${dateTypeName})`
          : isCloned
            ? `Clone: ${eventName || 'New event'} / ${eventTypeName} (${dateTypeName})`
            : `New ${eventTypeName} (${dateTypeName})`}
      </h2>
      {isEdit && record?.id ? <FirebasePushButton mode="event" record={record} /> : null}
    </div>
  );
};
